import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback, useState } from 'react';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import DesktopMultiArtStage from './DesktopMultiArtStage';
import DesktopSingleArtStage from './DesktopSingleArtStage';
export const DesktopArtStage = (props)=>{
    var _props_deviation_extended_additionalMedia, _props_deviation_extended;
    const hasAdditionalMedia = (_props_deviation_extended = props.deviation.extended) === null || _props_deviation_extended === void 0 ? void 0 : (_props_deviation_extended_additionalMedia = _props_deviation_extended.additionalMedia) === null || _props_deviation_extended_additionalMedia === void 0 ? void 0 : _props_deviation_extended_additionalMedia.length;
    const shouldRenderMultiImage = isMultiImageDeviation(props.deviation) && hasAdditionalMedia;
    const [zoomedImageSource, setZoomedImageSource] = useState();
    const logZoomBi = useZoomBiLogger(props.deviation);
    const onEnterZoomMode = useCallback((source)=>{
        setZoomedImageSource(source);
        logZoomBi(true);
    }, [
        logZoomBi
    ]);
    const onExitZoomMode = useCallback(()=>{
        setZoomedImageSource(undefined);
        logZoomBi(false);
    }, [
        logZoomBi
    ]);
    const isZoomed = !!zoomedImageSource;
    return shouldRenderMultiImage ? /*#__PURE__*/ React.createElement(DesktopMultiArtStage, _object_spread_props(_object_spread({}, props), {
        isZoomed: isZoomed,
        zoomedImageSource: zoomedImageSource,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    })) : /*#__PURE__*/ React.createElement(DesktopSingleArtStage, _object_spread_props(_object_spread({}, props), {
        isZoomed: isZoomed,
        zoomedImageSource: zoomedImageSource,
        onEnterZoomMode: onEnterZoomMode,
        onExitZoomMode: onExitZoomMode
    }));
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;

//# sourceMappingURL=DesktopArtStage.js.map